import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ActionsCreators } from "../../../actions";
import { actionCreators as contentActions } from "../../../actions/contents/carousel.actions";
import strings from "../../../helpers/Localization";
import Inputs from "../../../aGlobalDesign/Inputs/Inputs";
import Area from "../../../aGlobalDesign/Area/Area";
import ButtonSKA from "../../../aGlobalDesign/Buttons/ButtonSKA";
import CarouselItem from "../../../components/Carousel/CarouselItem";
import EmptyCarouselItem from "../../../components/Carousel/EmptyCarouselItem";
import Drawer from "../../../aGlobalDesign/Modal/Drawer";
import ButtonSkaRound from "../../../aGlobalDesign/Buttons/ButtonSkaRound";
import Loader from "../../../aGlobalDesign/Loader/Loader";
import CarouselCommitment from "./CarouselCommitment";

const CarouselInner = (props) => {

    const location = useLocation();

    const initialCarouselState = {
        adActivated: false,
        transition: "slide",
        displayTimeInSeconds: 5,
        adList: []
    };

    const [carousel, setCarousel] = useState(initialCarouselState);
    const [numberEmptyCarouselItem, setNumberEmptyCarouselItem] = useState(0);
    const [selectedAd, setSelectedAd] = useState(null);
    const [reloadKey, setReloadKey] = useState(0);
    const [temporaryAd, setTemporaryAd] = useState(null);
    const [temporaryCarousel, setTemporaryCarousel] = useState(initialCarouselState);
    const [isOpenDrawer, setIsOpenDrawer] = useState(false);
    const [carouselIsChanged, setCarouselIsChanged] = useState(false);
    const [isUploadingThumb, setIsUploadingThumb] = useState(false);



    const dispatch = useDispatch();
    const changeAppBarTitle = (payload) => dispatch(ActionsCreators.changeAppBarTitle(payload));
    const ChangeCurrentMenuName = (payload) => dispatch(ActionsCreators.ChangeCurrentMenuName(payload));
    const OpenDialog = (payload) => dispatch(ActionsCreators.OpenDialog(payload));
    const configuration = useSelector((state) => state.configuration);
    const currentUser = useSelector((state) => state.currentuser);
    const accessrights = currentUser && currentUser.accessrights ? currentUser.accessrights : null;


    const [reload, setReload] = useState(
        new URLSearchParams(new URL(window.location.href).search).get("reload")
    );


    useEffect(() => {
        changeAppBarTitle(strings.Carousel);
        ChangeCurrentMenuName("Carousel");
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);



    const getCarousel = () => {
        dispatch(
            contentActions.GetCarousel(
                (data) => {
                    const safeData = data ? data : initialCarouselState;
                    setCarousel(safeData);
                    setTemporaryCarousel(safeData);
                },
                (error) => {
                    console.error("Error GetCarousel :", error);
                }
            )
        );
    };


    useEffect(() => {
        const nextReload = new URLSearchParams(location.search).get("reload");
        if (nextReload && nextReload !== reload) {
            setReload(nextReload);
            getCarousel();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.search]);



    useEffect(() => {
        getCarousel();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);



    useEffect(() => {
        const totalCarouselItem = carousel.adList.length;
        setNumberEmptyCarouselItem(10 - totalCarouselItem);
    }, [carousel]);



    const onChangeDisplayTimeAdvertisement = (action) => {
        if (action === "add") {
            setTemporaryCarousel(prev => ({
                ...prev,
                displayTimeInSeconds: prev.displayTimeInSeconds + 1
            }));
        }
        else if (action === "subtract") {
            setTemporaryCarousel(prev => ({
                ...prev,
                displayTimeInSeconds: prev.displayTimeInSeconds - 1
            }));
        }
    };



    useEffect(() => {
        const areEqual
        = JSON.stringify(carousel) === JSON.stringify(temporaryCarousel);

        setCarouselIsChanged(!areEqual);
    }, [carousel, temporaryCarousel]);



    const downloadTemplate = () => {
        // TO DO
    };



    const moveAd = (id, direction) => {
        setTemporaryCarousel(prev => {
            const sorted = [...prev.adList].sort((a, b) => a.position - b.position);
            const index = sorted.findIndex(ad => ad.id === id);

            // If element don't exist, to do nothing
            if (index === -1) {
                console.warn("moveAd: ad not found for id", id);
                return prev;
            }

            const targetIndex = index + direction;

            // If we go beyond the limits (first verse up / last verse down), nothing changes
            if (targetIndex < 0 || targetIndex >= sorted.length) {
                return prev;
            }

            const updated = sorted.map(ad => {
                if (ad.id === sorted[index].id) {
                    return { ...ad, position: sorted[targetIndex].position };
                }
                if (ad.id === sorted[targetIndex].id) {
                    return { ...ad, position: sorted[index].position };
                }
                return ad;
            });

            const normalized = updated
                .sort((a, b) => a.position - b.position)
                .map((ad, i) => ({ ...ad, position: i }));

            return { ...prev, adList: normalized };
        });
    };



    const removeAd = (id) => {
        setTemporaryCarousel(prev => {

            const filtered = prev.adList.filter(ad => ad.id !== id);

            const normalized = filtered.map((ad, index) => ({
                ...ad,
                position: index
            }));

            const carouselObject = {
                ...prev,
                adList: normalized
            };

            dispatch(
                contentActions.EditCarousel(
                    carouselObject,
                    (data) => {
                        getCarousel();
                    },
                    (error) => {
                        console.error("Error removeAd :", error);
                    }
                )
            );

            return carouselObject;
        });
    };



    const onLoad = (ad) => {
        let d = ad;
        if (d === null) {
            const newId = -1;
            const lastPosition = Math.max(...temporaryCarousel.adList.map(i => i.position), 0) + 1;

            d = {
                id: newId,
                position: lastPosition,
                name: "",
                thumbMobile: JSON.stringify({ type: "img", name: "", url: "" }),
                actionButton: false,
                colorButton: "",
                textButton: "",
                link: ""
            };
        }
        const temp = createTemp(d);
        setSelectedAd(d);
        setTemporaryAd(temp);
        setIsOpenDrawer(true);
    };



    const createTemp = (element) => {
        const temp = {
            id: element.id,
            position: element.position,
            name: element.name,
            thumbMobile: element.thumbMobile,
            actionButton: element.actionButton,
            colorButton: element.colorButton,
            textButton: element.textButton,
            link: element.link
        };
        return temp;
    };



    const saveSelectedAd = () => {
        setTemporaryCarousel(prev => {
            const exists = prev.adList.some(ad => ad.id === temporaryAd.id);

            const updatedAdList = exists
            // Edit
                ? prev.adList.map(ad =>
                    ad.id === temporaryAd.id ? temporaryAd : ad
                )
            // Create
                : [...prev.adList, temporaryAd];

            const carouselObject = {
                ...prev,
                adList: updatedAdList
            };

            dispatch(
                contentActions.EditCarousel(
                    carouselObject,
                    (data) => {
                        getCarousel();
                    },
                    (error) => {
                        console.error("Error saveSelectedAd :", error);
                    }
                )
            );

            return carouselObject;
        });

        setIsOpenDrawer(false);
        setSelectedAd(null);
        setTemporaryAd(null);
    };




    const saveCarousel = () => {
        dispatch(
            contentActions.EditCarousel(
                temporaryCarousel,
                (data) => {
                    getCarousel();
                },
                (error) => {
                    console.error("Error saveCarousel :", error);
                }
            )
        );
    };



    const addDocumentToTempResource = (files) => {
        if (files.length <= 0) {return;}

        const file = files[0];
        const extension = file.name.split(".").pop().toLowerCase();
        const authorizeExtension = ["jpg", "jpeg", "png"];

        if (!authorizeExtension.includes(extension)) {
            OpenDialog({
                title: strings.WrongExtension,
                description: strings.TextWrongExtension + extension,
                primaryLabel: "OK",
                clickOutsideToClose: true
            });
            return;
        }

        if (file.size > configuration.multipartBodyLengthLimit) {
            OpenDialog({
                title: strings.fileTooBig,
                description: strings.fileTooBigDesc + configuration.multipartBodyLengthLimit / 1000000 + "MB",
                primaryLabel: "OK",
                clickOutsideToClose: true
            });
            return;
        }

        // Check resolution constraint
        const reader = new FileReader();
        const constraintResolutionThumbMobile = { width: 1440, height: 2560 };
        reader.onload = (e) => {
            const img = new Image();
            img.onload = () => {
                const width = img.width;
                const height = img.height;

                if (width !== constraintResolutionThumbMobile.width || height !== constraintResolutionThumbMobile.height) {
                    OpenDialog({
                        title: strings.IncorrectSize,
                        description: `${strings.ImageMustBeHaveDimensions} (${strings.youHave} ${width}X${height}).`,
                        primaryLabel: "OK",
                        clickOutsideToClose: true
                    });
                    return;
                }

                // Display loader pending upload image
                setIsUploadingThumb(true);

                // If resolution is OK : save image
                dispatch(contentActions.SaveTemporaryDocument(
                    file,
                    (newUrl) => {
                        setTemporaryAd(prev => ({
                            ...prev,
                            thumbMobile: JSON.stringify({
                                type: "img",
                                name: file.name,
                                url: newUrl
                            })
                        }));

                        // Hidden loader
                        setIsUploadingThumb(false);
                    }
                ));
            };

            img.onerror = () => {
                OpenDialog({
                    title: strings.Error,
                    description: strings.ImpossibleReadImage,
                    primaryLabel: "OK"
                });
            };

            img.src = e.target.result;
        };

        reader.readAsDataURL(file);
    };



    const getThumbUrl = (thumbMobile) => {
        if (!thumbMobile) {return "";}

        try {
            const obj = JSON.parse(thumbMobile);
            return obj ? obj.url : "";
        }
        catch (e) {
            console.error("Error parse thumbMobile:", e);
            return "";
        }
    };



    const isValidateDisabled = React.useMemo(() => {
        if (!temporaryAd) {return true;}

        const hasName = !!temporaryAd.name && temporaryAd.name.trim() !== "";
        const url = getThumbUrl(temporaryAd.thumbMobile);
        const hasUrl = !!url && url.trim() !== "";

        return !hasName || !hasUrl;
    }, [temporaryAd]);




    const sortedAds = [...temporaryCarousel ? temporaryCarousel.adList : []].sort(
        (a, b) => a.position - b.position
    );

    const [selectedPage, setSelectedPage] = useState("carousel");

    return (
        <Area
            helmet={strings.helmetAdvertisement}
            title={strings.Advertisement}
            navigatedId={selectedPage}
            navigation={[
                {
                    id: "carousel",
                    title: strings.Carousel,
                    onSelect: () => {
                        setSelectedPage("carousel");
                        setReloadKey(key => key + 1);
                        // reset UI + reload data
                        setIsOpenDrawer(false);
                        setSelectedAd(null);
                        setTemporaryAd(null);
                        setCarousel(initialCarouselState);
                        setTemporaryCarousel(initialCarouselState);
                        + getCarousel();
                    }
                },
                {
                    id: "comitment",
                    title: strings.Commitment,
                    onSelect: () => {
                        setSelectedPage("comitment");
                        setReloadKey(key => key + 1);
                    }
                }
            ]}
            customSideButtons={ selectedPage == "carousel" ?
                <div style={{ display: "flex", gap: "20px" }}>
                    <Inputs field={{
                        type: "togglebutton",
                        widthHorizontalFlexContainer: "auto",
                        name: temporaryCarousel.adActivated ? strings.AdActivated : strings.AdDisabled,
                        disabled: !accessrights || accessrights.hasPermission(700, "modify") <= 10,
                        checked: temporaryCarousel.adActivated,
                        onClick: () => {
                            setTemporaryCarousel(prev => ({
                                ...prev,
                                adActivated: !prev.adActivated
                            }));
                        }
                    }}/>
                    <ButtonSKA
                        type="primary-icon"
                        isDisabled={!carouselIsChanged}
                        onClick={saveCarousel}
                        nameIcon="save"
                        text={strings.save}
                    />
                </div> : null
            }
        >
            { selectedPage == "carousel" ?
                <div className='carousel-container' key={`carousel-${reloadKey}`}>
                    <div className='carousel-header'>
                        <div className='card-transition-carousel'>
                            <Inputs field={{
                                type: "circlesquareradiobuttons",
                                title: strings.Transition,
                                disabled: !accessrights || accessrights.hasPermission(700, "modify") <= 10,
                                width: "65px",
                                bold: true,
                                fontSize14: true,
                                elements: [
                                    {
                                        name: strings.Fade,
                                        checked: temporaryCarousel.transition === "fade",
                                        onClick: () => {
                                            setTemporaryCarousel(prev => ({
                                                ...prev,
                                                transition: "fade"
                                            }));
                                        }
                                    },
                                    {
                                        name: strings.Slide,
                                        checked: temporaryCarousel.transition === "slide",
                                        onClick: () => {
                                            setTemporaryCarousel(prev => ({
                                                ...prev,
                                                transition: "slide"
                                            }));
                                        }
                                    }
                                ]
                            }}/>
                        </div>
                        <div className='card-time-advertisement-carousel'>
                            <p style={{ fontWeight: 700 }}>{strings.DisplayingAdvertisements}</p>
                            <p>{`${temporaryCarousel.displayTimeInSeconds} secondes`}</p>
                            <ButtonSkaRound
                                type="secondary"
                                isDisabled={!accessrights || accessrights.hasPermission(700, "modify") <= 10}
                                onClick={() => onChangeDisplayTimeAdvertisement("subtract")}
                                nameIcon="subtract"
                            />
                            <ButtonSkaRound
                                type="secondary"
                                isDisabled={!accessrights || accessrights.hasPermission(700, "modify") <= 10}
                                onClick={() => onChangeDisplayTimeAdvertisement("add")}
                                nameIcon="add"
                            />
                        </div>
                        {/* <div className='card-advice-carousel'>
                            <ButtonSKA
                                type={"secondary-icon"}
                                onClick={() => downloadTemplate()}
                                nameIcon="upload"
                                text={strings.DownloadTemplate}
                            />
                        </div> */}
                    </div>
                    <div className="carousel-main">
                        {
                            sortedAds.map((item, index) => {
                                return (
                                    <CarouselItem key={index} ad={item} totalCarouselItems={temporaryCarousel.adList.length - 1} moveAd={moveAd} editAd={() => onLoad(item)} removeAd={() => removeAd(item.id)} />
                                );
                            })
                        }
                        {
                            Array.from({ length: numberEmptyCarouselItem }).map((_, index) =>
                                <EmptyCarouselItem key={`empty-${index}`} addAd={() => onLoad(null)} />
                            )
                        }
                    </div>
                    <Drawer open={isOpenDrawer}
                        onClose={() => {
                            setIsOpenDrawer(false);
                            setSelectedAd(null);
                            setTemporaryAd(null);
                        }}
                        title={temporaryAd && temporaryCarousel && temporaryCarousel.adList && temporaryCarousel.adList.some(ad => ad.id === temporaryAd.id) ? strings.EditAd : strings.CreateAd}
                        validationIcon={"save"}
                        validationTitle={strings.register}

                        isDisabledValidateButton={isValidateDisabled}
                        onValidate={ () => saveSelectedAd() }

                        heightBody={"auto"}
                    >
                        {
                            temporaryAd ?
                                <>
                                    <Inputs field={{
                                        type: "textfield",
                                        title: strings.name,
                                        width: "110px",
                                        placeholder: strings.name,
                                        error: temporaryAd.name === "",
                                        value: temporaryAd.name,
                                        onChange: (e) => {
                                            setTemporaryAd(prev => ({
                                                ...prev,
                                                name: e.target.value
                                            }));
                                        }
                                    }}/>
                                    <Inputs field={{
                                        type: "togglebutton",
                                        width: "110px",
                                        name: strings.Activate,
                                        title: strings.ActionButton,
                                        checked: temporaryAd.actionButton,
                                        onClick: () => {
                                            setTemporaryAd(prev => {
                                                const nextActionButton = !prev.actionButton;

                                                return {
                                                    ...prev,
                                                    actionButton: nextActionButton,
                                                    colorButton: nextActionButton ? "black" : "without",
                                                    textButton: nextActionButton ? prev.textButton : "",
                                                    link: nextActionButton ? prev.link : ""
                                                };
                                            });
                                        }
                                    }}/>
                                    {
                                        temporaryAd.actionButton ?
                                            <>
                                                <Inputs field={{
                                                    type: "selectElement",
                                                    width: "110px",
                                                    title: strings.ColorButton,
                                                    disabled: temporaryAd.actionButton === false,
                                                    adjustHeight: true,
                                                    preventEmpty: true,
                                                    elementsList: { results: [
                                                        { id: 1, name: strings.Black },
                                                        { id: 2, name: strings.White }
                                                    ] },
                                                    selectedElementId: temporaryAd.colorButton === "white" ? 2 : 1,
                                                    onSelectElement: (element) => {
                                                        setTemporaryAd(prev => ({
                                                            ...prev,
                                                            colorButton: element.id === 1 ? "black" : "white"
                                                        }));
                                                    } }}
                                                />
                                                <Inputs field={{
                                                    type: "textfield",
                                                    width: "110px",
                                                    title: strings.TextButton,
                                                    disabled: temporaryAd.actionButton === false,
                                                    placeholder: strings.TextButton,
                                                    error: temporaryAd.actionButton === true && temporaryAd.textButton === "",
                                                    value: temporaryAd.textButton,
                                                    maxlength: "25", // TO DO => Test on mobile device with different screen size for check max length is possible
                                                    onChange: (e) => {
                                                        setTemporaryAd(prev => ({
                                                            ...prev,
                                                            textButton: e.target.value
                                                        }));
                                                    }
                                                }}/>
                                                <Inputs field={{
                                                    type: "prefixedTextfield",
                                                    width: "110px",
                                                    title: strings.link,
                                                    prefix: "https://",
                                                    value: temporaryAd.link,
                                                    onChange: (e) => {
                                                        setTemporaryAd(prev => ({
                                                            ...prev,
                                                            link: e.target.value
                                                        }));
                                                    }
                                                }}/>
                                            </>
                                            :
                                            null
                                    }
                                    <span></span>
                                    <Inputs field={{ type: "divider" }}/>
                                    <div className="ContentTitle">{strings.Visual} </div>
                                    {
                                        isUploadingThumb ?
                                            <Loader dimensions={"20px"} color={"var(--primary-base)"} />
                                            :
                                            <Inputs field={{
                                                type: "importfile",
                                                width: "110px",
                                                title: strings.Mobile,
                                                access: "image",
                                                value: temporaryAd.thumbMobile && JSON.parse(temporaryAd.thumbMobile).name ? JSON.parse(temporaryAd.thumbMobile).name : "",
                                                thumbnail: temporaryAd.thumbMobile && JSON.parse(temporaryAd.thumbMobile).url ? JSON.parse(temporaryAd.thumbMobile).url : "",
                                                onAddFiles: (files) => {
                                                    addDocumentToTempResource(files);
                                                }
                                            }}/>
                                    }
                                </> : null
                        }
                    </Drawer>
                </div> : null
            }
            { selectedPage == "comitment" ? <CarouselCommitment key={`commitment-${reloadKey}`} /> : null }
        </Area>
    );
};


// export default Carousel;


const Carousel = (props) => {
    const location = useLocation();
    const reload = new URLSearchParams(location.search).get("reload") || "0";

    // key => remount complet de CarouselInner quand reload change
    return <CarouselInner key={reload} {...props} />;
};

export default Carousel;


